var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import resolveChunks from './Resolvable';
import { createNotFoundChunk } from './Chunks';
import { concatMatcherIterators, createMatcherIterator } from './Matcher';
export function createChunksMatcher(maybeResolvable, forceChildMatcher, getChunks, exact, processDuringCrawl, predicate) {
    function chunksMatcherGenerator(request, child) {
        var unmatchedPathnamePart, parentIterator;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    unmatchedPathnamePart = request.path;
                    if (!((exact === undefined ? !child : exact) && unmatchedPathnamePart && unmatchedPathnamePart !== '/')) return [3 /*break*/, 2];
                    return [4 /*yield*/, [createNotFoundChunk(request)]];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 4];
                case 2:
                    parentIterator = ((request.crawler && !processDuringCrawl) || (predicate && !predicate(request)))
                        ? empty()
                        : resolveChunks(maybeResolvable, request, function (value) { return getChunks(value, request); });
                    return [5 /*yield**/, __values((child ? concatMatcherIterators(parentIterator, createMatcherIterator(child, request)) : parentIterator))];
                case 3:
                    _a.sent();
                    _a.label = 4;
                case 4: return [2 /*return*/];
            }
        });
    }
    return (function (childGenerator) { return function (request) {
        return chunksMatcherGenerator(request, forceChildMatcher ? forceChildMatcher(childGenerator) : childGenerator);
    }; });
}
function empty() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, []];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=createChunksMatcher.js.map